import { Input }    from "@mantine/core";
import { useState } from "react";

import { useFocusableInput } from "_common/custom-hooks/useFocusableInput";
import Icon                  from "_components/atoms/icon";
import Typography            from "_components/atoms/typography";
import useStyles             from "_styles/molecules/createPoll";

const addStartIndex = idx => {
	switch ( idx ) {
		case 0:
			return "A.";

		case 1:
			return "B.";

		case 2:
			return "C.";

		case 3:
			return "D.";

		default:
			break;
	}
};

const checkOptions = ( options, optionLengthMin ) => {
	let flag = true;

	options?.forEach ( ele => {
		if ( ele?.length < optionLengthMin )
			flag =  false;
	} );

	return flag;
};

const OptionField = ( { idx, option, handleOptionChange, handleRemoveOption, optionLengthMax } ) => {

	const { classes }         = useStyles ( undefined, { name: "styles" } );
	const [ focus, setFocus ] = useState ( false );

	const handleBlur = () => {
		setFocus ( false );
	};

	const handleFocus = event => {
		event.target.select ();
		setFocus ( true );
	};

	const showWarning = ( !option?.length && !focus );

	return (
		<div key   = { idx }
			className = { classes.optionFieldWrapper }
		>
			<div style = { { display: "flex" } }>
				<Input
					key          = { idx }
					multiline
					aria-label   = "textarea"
					autoFocus    = { idx > 1 ? true : false }
					className    = { classes.optionInput }
					classNames   = { { input: classes.optioninputinput, wrapper: classes.optionWrapper, icon: classes.optionIcon } }
					icon         = { (
						<div className = { classes.index }>
							{addStartIndex ( idx )}
						</div>
					) }
					maxLength    = { optionLengthMax }
					// maxRows = { 2 }
					onBlur       = { handleBlur }
					onChange     = { e => handleOptionChange ( e, idx ) }
					onFocus      = { handleFocus }
					onKeyDown    = { e => {
						if ( e.key === "Enter" ) {
						  e.preventDefault ();
						}
					 } }
					rightSection = { focus && (
						<div className = { classes.lettersLength }>
							{optionLengthMax - option?.length}
						</div>
	 ) }
					value        = { option }
				/>

				{idx > 1 && (
					<div className = { classes.iconWrapper }>
						<Icon
							className = { classes.crossButton }
							name      = "cross"
							onClick   = { () => handleRemoveOption ( idx ) }
						/>
					</div>
				)}
			</div>

			{showWarning && (
				<Typography
					className = { classes.warningText }
					title     = "Must Contain between 1 – 65 characters"
				/>
			)}

		</div>
	);
};

const component = ( {
	closeCreatePollDrawer,
	options,
	question,
	handleQuestion,
	handlePostPoll,
	handleAddOption,
	handleRemoveOption,
	handleOptionChange,
	pollsConfig
} ) => {

	const { numberOfOptionsMax,
		optionLengthMax,
		optionLengthMin,
		titleLengthMax,
		titleLengthMin }                  = pollsConfig;
	const [ focus, setFocus ] = useState ( false );
	const optLengthFlag       = checkOptions ( options, optionLengthMin );
	const disablePostButton   = ( question?.length < titleLengthMin ) || !optLengthFlag;
	const { classes }         = useStyles ( { disablePostButton } );
	const { setInputRef }     = useFocusableInput ( true, 200 );

	const handleBlur = () => {
		setFocus ( false );
	};

	const handleFocus = () => {
		setFocus ( true );
	};

	return (
		<>

			<div className = { classes.header }>
				<Typography
					className = { classes.headerText }
					title     = "Create Poll"
				/>

				<Icon
					className = { classes.crossButton }
					name      = "cross"
					onClick   = { closeCreatePollDrawer }
				/>
			</div>

			<div className = { classes.createPollSection }>
				<div className = { classes.inputWrapper }>

					<Input
						multiline
						classNames   = { { input: classes.questionInput } }
						maxLength    = { titleLengthMax }
						// maxRows     = { 3 }
						onBlur       = { handleBlur }
						onChange     = { handleQuestion }
						onFocus      = { handleFocus }
						onKeyDown    = { e => {
							if ( e.key === "Enter" ) {
							  e.preventDefault ();
							}
						 } }
						placeholder  = "Enter Your Question here"
						value        = { question }
					/>

					{focus && (
						<div className = { classes.inputWordsWrapper }>
							<span>
								{question.length}
								/

								{titleLengthMax}
							</span>
						</div>
					)}

				</div>

				<div className = { classes.optionsWrapper }>
					{options.map ( ( option, idx ) => {
						return (
							<OptionField
								key                = { idx }
								handleOptionChange = { handleOptionChange }
								handleRemoveOption = { handleRemoveOption }
								idx                = { idx }
								option             = { option }
								optionLengthMax    = { optionLengthMax }
							/>
						);
					} )}

					{( options.length < numberOfOptionsMax ) && (
						<div
							className = { classes.addOptionButton }
							onClick   = { handleAddOption }
						>
							+ Add Option
						</div>
					)}
				</div>

				<div
					className = { classes.postPoll }
					onClick   = { () => {
						!disablePostButton ? handlePostPoll () : null;
					} }
				>
					Post Poll
				</div>
			</div>

		</>
	);
};

export default component;
